import { render } from "./CustumLabel.vue?vue&type=template&id=02c7078f"
import script from "./CustumLabel.vue?vue&type=script&lang=js"
export * from "./CustumLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__